<template>
    <settings-editor-base
        v-bind:label="label"
    >
        <template v-slot="{inputId}">
            <input
                    v-bind:id="inputId"
                    v-bind:value="value"
                    @input="$emit('input', $event.srcElement.value)"
                    class="form-control"
                    type="text"
                    v-bind:placeholder="placeholder"
            >
        </template>
    </settings-editor-base>
</template>

<script>
    import SettingsEditorBase from "./SettingsEditorBase.vue";
    
    export default {
        name: "settings-textbox",
        components: {SettingsEditorBase},
        props: {
            label: {
                type: String,
                required: true
            },
            placeholder: String,
            value: String
        }
    };
</script>
